export function roundNumber(number, decimalPoints) {
  const mul = Math.pow(10, decimalPoints);
  return Math.round(number * mul) / mul;
}

export function parseNumberString(value) {
  return parseFloat(value.replace(',', '.'));
}
